import * as React from 'react';
const SvgTesting = props => (
  <svg xmlns='http://www.w3.org/2000/svg' xmlSpace='preserve' viewBox='0 0 512 512' {...props}>
    <path
      fill={props.fill || 'black'}
      d='M466.902 375.706V134.421H303.327V63.867h15.493V32.52H193.181v31.347h15.493v70.553H45.098v241.286H0V479.48h512V375.706h-45.098zM230.693 158.547l9.328-4.13v-90.55h31.959v90.549l9.328 4.13a62.649 62.649 0 0 1 27.415 23.538H203.278a62.634 62.634 0 0 1 27.415-23.537zm-37.254 54.886h125.123c.029.79.046 1.582.046 2.377 0 34.521-28.086 62.607-62.608 62.607s-62.607-28.086-62.607-62.607c0-.795.017-1.588.046-2.377zM76.445 165.768h100.068c-9.259 14.7-14.468 31.964-14.468 50.043 0 51.806 42.148 93.954 93.954 93.954 51.807 0 93.955-42.148 93.955-93.954 0-18.078-5.209-35.343-14.468-50.043h100.068v209.711H76.445V165.768zm404.208 282.365H31.347v-41.08h449.306v41.08z'
    />
    <path fill={props.fill || 'black'} d='M245.154 416.758h21.682v21.682h-21.682z' />
  </svg>
);
export default SvgTesting;
